import type { MatchRules } from "../ability";
import type { SimEvent } from "../events";
import type { FighterState } from "../state";

export interface ActionContext {
  readonly self: FighterState;
  readonly other: FighterState;
  readonly side: 0 | 1;
  readonly rules: MatchRules;
  readonly frame: number;
  readonly emit: (event: SimEvent) => void;
}

/** Обработчик действия способности: целые числа, без времени и случайности вне снимка (GAME-02). */
export type ActionHandler = (context: ActionContext, params: Readonly<Record<string, number>>) => void;

const handlers = new Map<string, ActionHandler>();

/** Новое действие регистрируется здесь и только здесь; исполнитель способностей его поимённо не знает (GAME-06). */
export function registerAction(type: string, handler: ActionHandler): void {
  if (handlers.has(type)) throw new Error(`Действие «${type}» уже зарегистрировано`);
  handlers.set(type, handler);
}

export function hasAction(type: string): boolean {
  return handlers.has(type);
}

export function runAction(type: string, context: ActionContext, params: Readonly<Record<string, number>>): void {
  const handler = handlers.get(type);
  if (!handler) throw new Error(`Нет обработчика действия «${type}»`);
  handler(context, params);
}
